<template>
  <div class="container">
    <HeadingOne class="-margin-md">審査結果のご確認</HeadingOne>

    <NoticeBox
      v-if="Object.keys(errors).length > 0"
      class="-error _mb-sm-40 _mb-md-60"
    >
      <NoticeHeader>
        <h3 class="heading">以下の内容をご確認ください。</h3>
      </NoticeHeader>
      <NoticeBody>
        <ul>
          <li>確認コードを正しく入力してください。</li>
        </ul>
      </NoticeBody>
    </NoticeBox>

    <p class="_mb-sm-20 _mb-md-30">
      審査が完了いたしましたので、当社よりお送りさせていただいたハガキに記載の「確認コード」をご入力いただき、ご利用限度額、お借り入れ利率をご確認ください。なお、審査完了のご案内から1週間程度経過してもハガキが届かない場合は、以下のお問い合わせ先へご連絡ください。
    </p>
    <p>
      au PAY スマートローン 新規入会デスク<br />
      0120-988-135(通話料無料)<br />
      受付時間：9:00～18:00(年中無休)<br />
      ※番号のおかけ間違いにご注意ください。
    </p>

    <form novalidate @submit.prevent="submitConfirmationCode">
      <TableGroup>
        <TableBox class="-entry">
          <TableBody>
            <TableRow>
              <TableHeader>確認コード</TableHeader>
              <TableData :has-error="errors['confirmation_code']">
                <InputGroup
                  :errors="errors"
                  :prop-names="['confirmation_code']"
                >
                  <InputgroupAppend>
                    <InputItem
                      id="confirmCode"
                      v-model="confirmationCode.confirmation_code"
                      class="-md"
                      :maxlength="7"
                    ></InputItem>
                  </InputgroupAppend>
                </InputGroup>
              </TableData>
            </TableRow>
          </TableBody>
        </TableBox>
      </TableGroup>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-main" @click.prevent="submitConfirmationCode">
          審査結果のご確認へ
        </BtnMain>
      </BtngroupSingle>
    </form>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import { goToErrorPage, scrollTop } from "@/utils/Other";
import { initCredentials } from "@/utils/Auth";
import { submitConfirmationCodeLambdaInvoke } from "@/utils/LambdaHelper";
import HeadingOne from "@/components/heading/HeadingOne";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import InputGroup from "@/components/input/InputGroup";
import InputgroupAppend from "@/components/input/InputgroupAppend";
import InputItem from "@/components/input/InputItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";

export default {
  name: "En020",
  components: {
    NoticeHeader,
    NoticeBox,
    NoticeBody,
    BtnMain,
    BtngroupSingle,
    InputItem,
    InputgroupAppend,
    InputGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "審査結果のご確認",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,審査,審査結果",
    });
  },
  data() {
    return {
      errors: {},
      isDisabled: false,
      confirmationCode: {
        confirmation_code: "",
      },
    };
  },
  methods: {
    submitConfirmationCode() {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        initCredentials()
          .then(() => {
            submitConfirmationCodeLambdaInvoke(this.confirmationCode)
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  this.$router.push({ name: "en010" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style scoped></style>
